var _circle, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBall0(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 5,
    viewBox: "0 0 5 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    fill: "url(#paint0_linear_357_36)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.73011 3.03977C2.59801 3.0393 2.4839 3.00876 2.38778 2.94815C2.29167 2.88755 2.21757 2.80019 2.16548 2.68608C2.1134 2.57197 2.08759 2.43513 2.08807 2.27557C2.08854 2.11553 2.11458 1.97964 2.16619 1.8679C2.21828 1.75616 2.29214 1.67116 2.38778 1.61293C2.4839 1.55469 2.59801 1.52557 2.73011 1.52557C2.86222 1.52557 2.97633 1.55492 3.07244 1.61364C3.16856 1.67187 3.24266 1.75687 3.29474 1.86861C3.34683 1.98035 3.37263 2.116 3.37216 2.27557C3.37216 2.43608 3.34612 2.57339 3.29403 2.6875C3.24195 2.80161 3.16785 2.88897 3.07173 2.94957C2.97609 3.00971 2.86222 3.03977 2.73011 3.03977ZM2.73011 2.71875C2.7983 2.71875 2.85417 2.68324 2.89773 2.61222C2.94176 2.54072 2.96354 2.4285 2.96307 2.27557C2.96307 2.17566 2.95313 2.09399 2.93324 2.03054C2.91335 1.96709 2.88589 1.92022 2.85085 1.88991C2.81581 1.85914 2.77557 1.84375 2.73011 1.84375C2.66193 1.84375 2.6063 1.87831 2.56321 1.94744C2.52012 2.01657 2.49811 2.12595 2.49716 2.27557C2.49669 2.37737 2.50639 2.46117 2.52628 2.52699C2.54616 2.59233 2.57363 2.64062 2.60866 2.67188C2.64418 2.70312 2.68466 2.71875 2.73011 2.71875Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_357_36",
    x1: 1.13281,
    y1: 0.364583,
    x2: 3.6849,
    y2: 4.71354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.435612,
    stopColor: "#008000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.579359,
    stopColor: "#8F00FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBall0);
export default __webpack_public_path__ + "static/media/ball-0.716f0bf21df723f1d6a335e37919d8ff.svg";
export { ForwardRef as ReactComponent };